export const HTML_SANITIZE_OPTIONS = Object.freeze({
  ALLOWED_TAGS: Object.freeze(["b", "strong", "i", "em", "u", "br", "p", "span", "ul", "li", "a"]),
  ALLOWED_ATTR: Object.freeze(["href", "target", "rel"])
});

export const ATTESTATION_SANITIZE_OPTIONS = Object.freeze({
  ALLOWED_TAGS: Object.freeze(["a", "b", "strong", "em"]),
  ALLOWED_ATTR: Object.freeze(["href", "target", "rel"])
});
